import React, { Fragment, useEffect } from 'react';   
import ImagingOrder from './ImagingOrder';  
  

const Imaging = ({ patient_id, connection }) =>{ 

    useEffect(() =>{  },[ patient_id ])
    return(
        <Fragment>
            <ImagingOrder 
                patient_id={patient_id} 
                connection = {connection}
            />
        </Fragment>
    )
}

export default Imaging;